import { useParams } from "react-router-dom";
import { isSupabaseEnabled } from "../lib/supabaseClient";
import VolunteerBrandMark from "../components/VolunteerBrandMark";
import AuthScreenHeader from "../components/AuthScreenHeader";
import ResetPasswordFlow from "../components/ResetPasswordFlow";

const volunteerBrand = <VolunteerBrandMark height={72} />;

// Where the volunteer "Reset password" email link lands. The flow
// itself (recovery-session detection, new-password form) is shared
// with the staff surface — components/ResetPasswordFlow.tsx.
export default function VolunteerResetPassword() {
  const { parish: slug } = useParams();

  if (!isSupabaseEnabled) {
    return (
      <main className="page page--sign-in">
        <div className="sign-in">
          <AuthScreenHeader
            brand={volunteerBrand}
            title="Reset your password"
            subtitle="Password reset isn't available yet. Please check back soon."
          />
        </div>
      </main>
    );
  }

  return (
    <ResetPasswordFlow
      brand={volunteerBrand}
      signInPath={`/${slug ?? ""}/login`}
      doneMessage="Your password's been updated. Sign in with your new password to see your Mass schedule."
      showFooter
    />
  );
}
